import { render, staticRenderFns } from "./CustomerSearchTable.vue?vue&type=template&id=4b9b1fd8&scoped=true&"
import script from "./CustomerSearchTable.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSearchTable.vue?vue&type=style&index=0&id=4b9b1fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b1fd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
